import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Spin } from 'antd';

import {
    openModalDocument,
    openModalEvent,
    openModalPerson,
    openModalProject,
    openModalCompany
} from 'actions/modalActions';
import { spinDelay } from 'constants/defaults';
import TableComponent from './tableComponents/TableComponent';

const dispatchToProps = (dispatch) => ({
    cellHandlers: bindActionCreators({
        openModalDocument,
        openModalEvent,
        openModalPerson,
        openModalProject,
        openModalCompany
    }, dispatch)
});

@connect(null, dispatchToProps)
export default class Table extends Component {
    static propTypes = {
        meta: PropTypes.object,
        items: PropTypes.array,
        settings: PropTypes.object,
        hideGroups: PropTypes.bool,

        sort: PropTypes.object,
        pagination: PropTypes.object,

        tableConfig: PropTypes.shape({
            defaultColumns: PropTypes.array.isRequired,
            getTemplate: PropTypes.func.isRequired,
            headerTranslatePrefix: PropTypes.string.isRequired,
            showTableLabel: PropTypes.bool,
        }),

        cellHandlers: PropTypes.object,
        setPagination: PropTypes.func,
        setSort: PropTypes.func,
        setColumnWidth: PropTypes.func,
        refresh: PropTypes.func,

        className: PropTypes.string,
    };

    render() {
        const { meta, items, settings, sort, pagination, hideGroups } = this.props;
        const { defaultColumns, getTemplate, headerTranslatePrefix, showTableLabel } = this.props.tableConfig;
        const { refresh, cellHandlers, setPagination, setSort, setColumnWidth } = this.props;

        return (
            <Spin spinning={meta.pending} delay={spinDelay}>
                <div className={cx('react-table-container', this.props.className)}>
                    <div>
                        <TableComponent
                            refresh={refresh}
                            meta={meta}
                            items={items}
                            settings={settings}
                            sort={sort}
                            pagination={pagination}
                            defaultColumns={defaultColumns}
                            getTemplate={getTemplate}
                            headerTranslatePrefix={headerTranslatePrefix}
                            cellHandlers={cellHandlers}
                            handlePagination={setPagination}
                            handleSort={setSort}
                            handleColumnResize={setColumnWidth}
                            showTableLabel={showTableLabel}
                            hideGroups={hideGroups}
                        />
                    </div>
                </div>
            </Spin>
        );
    }
}
